/* Global & Mobile Navigation Handling
 *
 * @file combined
 *
 */
const Navigation = {
    mobile: () => {
        const body = document.body;
        const menuToggle = document.getElementById('menu-toggle');
        const mobileMenuItem = document.querySelectorAll('.menu-mobile .nav__menu .menu-item');

        // Menu Toggle.
        menuToggle.addEventListener('click', () => {
            body.classList.contains('menu-mobile-active') ? body.classList.remove('menu-mobile-active') : body.classList.add('menu-mobile-active');
        });

        // Mobile Sub Menu.
        Array.from(mobileMenuItem).forEach(menuItem => {
            menuItem.classList.remove('expanded');
            menuItem.addEventListener('click', () => {
                this.classList.contains('expanded') ? this.classList.remove('expanded') : this.classList.add('expanded');
            });
        });
    },
    allNavs: () => {
        // Store header for later
        const header = document.querySelector('.rs-header');

        // Do not follow hash links or those opening a submenu.
        const deadLinks = document.querySelectorAll('.nav li:not(.rs-modal-link) > a[href="#"], .nav .menu-item-has-children > a');
        Array.from(deadLinks).forEach(link => {
            link.addEventListener('click', e => e.preventDefault());
        });

        // Flag navbar with class when page scrolled.
        if (window.requestAnimationFrame) {
            let curScrollY;
            let lastScrollY = window.scrollY;

            const onScroll = () => {
                // Style navbar when scrolled a minimum distance.
                if (curScrollY >= 60 && !header.classList.contains('rs-header--is-sticky')) {
                    header.classList.add('rs-header--is-sticky');
                } else if (curScrollY < 60 && header.classList.contains('rs-header--is-sticky')) {
                    header.classList.remove('rs-header--is-sticky');
                }
            };

            // Fire "onScroll" only when window is scrolled vertically.
            const rafLoop = () => {
                curScrollY = window.scrollY;

                if (lastScrollY === curScrollY) {
                    window.requestAnimationFrame(rafLoop);
                    return;
                }

                // Fire onScroll function if window scrolls vertically.
                onScroll();

                lastScrollY = curScrollY;
                window.requestAnimationFrame(rafLoop);
            };

            // Initialize state based on browser initial scroll position.
            onScroll();
            // Start loop.
            rafLoop();
        }
    },
    init: () => {
        Navigation.allNavs();
        Navigation.mobile();
    },
};

export default Navigation;
